import { isBoolean, isString, isValidNumber, ObjectAccessor } from '@dateam/ark';
import { parseObservationField } from './shared';
import { RecordValue, ValidationError } from './types';

/*
 ** Cicadelle Flavescence Dorée
 ** - presence: Présence
 **     Booleen => Liste ['Oui', 'Non']
 **     Required
 ** - count: Comptage // /50 feuilles
 **     0 <= Value <= 50
 */

type CurrentObservation = App.Observation34;
type CurrentApiObservation = App.Api.Observation34;

export const validate = (
    observation: CurrentObservation,
    _: App.InspectionPlotWithRecord
): Record<never, never> | Record<ObjectAccessor<Omit<CurrentObservation, 'previous'>>, ValidationError> => {
    const validation = {} as Record<ObjectAccessor<Omit<CurrentObservation, 'previous'>>, ValidationError>;

    const { ignored, presence, count } = observation;

    if (ignored === true) return validation;

    // The value must be defined
    if (presence == null || !isBoolean(presence)) {
        validation.presence = {
            field: 'presence',
            type: 'error',
            code: 'required'
        };
    }

    if (count != null) {
        if (!isValidNumber(count) || count < 0 || count > 50) {
            validation.count = {
                field: 'count',
                type: 'error',
                code: 'format'
            };
        }
    }

    return validation;
};

export const parse = (observation: CurrentApiObservation): CurrentObservation => {
    const {
        id,
        manuallyAdded,
        ignored,
        updatedOn,
        previous,
        presence,
        count
    } = observation;
    const parsedObs = {
        id,
        manuallyAdded,
        ignored,
        updatedOn,
        previous,
        isSyncing: false,
        isValid: true,
        hasChanged: false
    } as CurrentObservation;

    parsedObs.presence = parseObservationField(presence);
    parsedObs.count = parseObservationField(count);

    return parsedObs;
};

export const map = (observation: CurrentObservation): CurrentApiObservation => {
    const {
        id,
        manuallyAdded,
        ignored,
        updatedOn,
        presence,
        count
    } = observation;
    const mappedObs = {
        id,
        manuallyAdded,
        ignored,
        updatedOn
    } as CurrentApiObservation;

    mappedObs.presence = presence !== undefined ? new RecordValue(presence) : null;
    mappedObs.count = count !== undefined ? new RecordValue(count) : null;

    return mappedObs;
};